import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.pexels.com/photos/6195951/pexels-photo-6195951.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Professional Cleaning Services"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 via-slate-900/75 to-slate-900/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-teal-600/20 backdrop-blur-sm border border-teal-500/30 rounded-full px-4 py-2 mb-6">
            <Sparkles className="w-4 h-4 text-teal-400" />
            <span className="text-teal-300 text-sm font-medium">Columbus, Ohio's Trusted Cleaning Service</span>
          </div>

          {/* Main Headline */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Professional Cleaning Services in Columbus, Ohio
          </h1>

          {/* Subheadline */}
          <p className="text-xl md:text-2xl text-slate-200 mb-10 leading-relaxed">
            Reliable residential and commercial cleaning with detailed service and flexible scheduling
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              onClick={() => scrollToSection('contact')}
              size="lg"
              className="bg-teal-600 hover:bg-teal-700 text-white text-lg px-8 py-6 shadow-xl hover:shadow-2xl transition-all duration-300 group"
            >
              Request a Free Quote
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              onClick={() => scrollToSection('services')}
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-slate-900 text-lg px-8 py-6 backdrop-blur-sm transition-all duration-300"
            >
              View Services
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-2 gap-8 mt-16 pt-8 border-t border-white/20 max-w-md">
            <div>
              <div className="text-3xl font-bold text-white mb-1">5 Star</div>
              <div className="text-slate-300 text-sm">Service Quality</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-white mb-1">Local</div>
              <div className="text-slate-300 text-sm">Columbus Based</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
